import { PCC_RELEASE_CURRENCY_SYMBOL_UPDATE_FOR_SAUDI_RIYAL } from '@app/constants/featureFlags';
import { isRTLLang } from '@app/utils';
import { checkIsRiyal, priceDisplayFormat } from '@app/utils/paymentUtils';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ProductPriceDetails = ({ currency, price, showCurrency, unitPrice }) => {
  const [t] = useTranslation();
  const showUnitPrice = unitPrice && unitPrice !== price;
  const eaLabel = t('ITEM_EA_ABB');
  const getPriceSuffix = showCurrency =>
    showCurrency ? ` ${currency} ${t('ITEM_EA_ABB')}` : ` ${t('ITEM_EA_ABB')}`;
  const langId = useSelector(s => s.common?.langId);
  const isRTL = isRTLLang(langId);
  const currencySymbolFeatureFlag = useSelector(
    state =>
      state?.featureFlag?.[PCC_RELEASE_CURRENCY_SYMBOL_UPDATE_FOR_SAUDI_RIYAL]
  );
  const isRiyal = currencySymbolFeatureFlag && checkIsRiyal(currency);
  return (
    <div className={'ms-0 me-auto'}>
      <p className={'text-end u-color--DarkGray text-univers--bold mb-0'}>
        {isRiyal ? (
          <span className={cx('text-md u-color--DarkGray text-univers--bold')}>
            {priceDisplayFormat({
              price: `${price} ${eaLabel}`,
              currency,
              priceWrapperClasses: 'px-1',
              isRTL: isRTL,
              size: 'sm'
            })}
          </span>
        ) : (
          <>
            <span
              className={cx('text-md u-color--DarkGray text-univers--bold')}
            >
              {price}
            </span>
            {getPriceSuffix(showCurrency)}
          </>
        )}
      </p>
      {showUnitPrice && (
        <p className={'text-end mb-0'}>
          {isRiyal ? (
            <span className="text-line-through text-univers u-color--DarkGray">
              {priceDisplayFormat({
                price: `${unitPrice} ${eaLabel}`,
                currency,
                priceWrapperClasses: 'px-1',
                isRTL: isRTL,
                size: 'xs'
              })}
            </span>
          ) : (
            <>
              <span className="text-line-through text-univers u-color--DarkGray">
                {unitPrice}
              </span>
              {getPriceSuffix(showCurrency)}
            </>
          )}
        </p>
      )}
    </div>
  );
};

ProductPriceDetails.propTypes = {
  currency: PropTypes.string,
  price: PropTypes.string,
  showCurrency: PropTypes.bool,
  unitPrice: PropTypes.string
};

export default ProductPriceDetails;
